import { render, staticRenderFns } from "./StockCalcSumaryTable.vue?vue&type=template&id=2d3c17db"
import script from "./StockCalcSumaryTable.vue?vue&type=script&lang=js"
export * from "./StockCalcSumaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports